import React from "react";
import {
  Select,
  MenuItem,
  Checkbox,
  InputLabel,
  FormControl,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  customSelect: {
    width: "100%",
    fontSize: 16,
    cursor: "pointer",
    fontWeight: 500,
    color: "#000",
    borderRadius: "6px",
    "&:focus": {
      border: "none",
    },
    "& .MuiSelect-select": {
      width: "100%",
      fontSize: "16px",
      marginBottom: "0 !important",
      borderColor: "#142C5C",
      border: "1px solid #142C5C ",
      borderRadius: "6px",
    },
    "& .MuiFormLabel-root-MuiInputLabel-root.Mui-focused": {
      color: "#142C5C !important",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "blue", // Change focused label color to blue
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& fieldset": {
        borderColor: "#142C5C",
      },
      "&:hover fieldset": {
        borderColor: "#142C5C",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#142C5C",
      },
    },
    "& .MuiSelect-outlined": {
      padding: "12px 15px",
    },
  },
});

function CustomMultiSelect({
  edit = true,
  onChange,
  value = [],
  placeholder,
  selectOptions = [],
  readOnly,
  categoryTypes,
  sx,
}) {
  const [selectedValues, setSelectedValues] = React.useState(value);
  const classes = useStyles();

  const handleChange = (event) => {
    const {
      target: { value: selected },
    } = event;
    // Check if the newly selected values include a category that has more than 7 audios
    // const selectedCategoryIds = Array.isArray(selected) ? selected : [];

    // const invalidSelection = selectedCategoryIds.find(id => {
    //     const category = categoryTypes.find(cat => cat._id === id);
    //     return category && category.audios.length > 7;
    // });

    setSelectedValues(selected);
    onChange(selected);
  };

  return (
    <FormControl
      sx={{
        marginTop: "16px",
        "& .MuiFormLabel-root-MuiInputLabel-root.Mui-focused": {
          color: "#142C5C !important",
        },
      }}
      className={classes.input}
      fullWidth
      margin="normal"
    >
      <InputLabel
        id="category-select-label"
        sx={{
          color: "gray",
          "& .Mui-focused": {
            color: "#142C5C !important",
          },
        }}
      >
        {placeholder}
      </InputLabel>
      <Select
        multiple
        labelId="category-select-label"
        id="category-select"
        value={selectedValues}
        onChange={handleChange}
        displayEmpty
        label={placeholder}
        renderValue={(selected) => {
          const selectedArray = Array.isArray(selected) ? selected : [];
          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                maxHeight: "35px",
                overflowY: "auto",
              }}
            >
              {selectOptions
                .filter((option) => selectedArray.includes(option._id))
                .map((option) => (
                  <span
                    key={`${option._id}-${option.name || option.title}`}
                    style={{
                      borderRadius: "4px",
                      padding: "5px",
                      fontSize: "12px",
                      backgroundColor: "#142C5C",
                      color: "white",
                    }}
                  >
                    {option.name || option.title}
                  </span>
                ))}
            </div>
          );
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              width: "auto",
            },
          },
        }}
        sx={{
          height: "55px",
          "& .MuiSelect-select": {
            padding: "8px 14px",
            fontSize: "14px",
            color: "black",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "4px",
          },
          "& .MuiSelect-select.Mui-disabled": {
            color: "black",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            "& legend": {
              width: "500px",
            },
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            "& legend": {
              width: "auto",
            },
          },
          "&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
            "& legend": {
              width: selectedValues?.length > 0 ? "auto" : "0px",
            },
          },
          "& .MuiInputLabel-root": {
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -9px) scale(0.75)",
              backgroundColor: "white",
              padding: "0 4px",
            },
          },
        }}
      >
        {selectOptions.map((option) => {
          return (
            <MenuItem
              key={option._id}
              value={option._id}
              sx={{
                backgroundColor: "white",
                color: "black",
                "& .MuiTypography-root": {
                  color: "black",
                },
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  sx={{
                    color: "#142C5C",
                    "& svg": {
                      fontSize: "1.5rem",
                      color: "#142C5C !important", // Change the size of the checkbox icon
                    },
                  }}
                  checked={selectedValues.indexOf(option._id) > -1}
                />
                <div style={{ flex: 1 }}>
                  <div>{option.name || option.title}</div>
                </div>
              </div>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

export default CustomMultiSelect;
